import { useAnlageassistentFormContext } from '@/domain/mitarbeiter/features/anlageassistent/context/AnlageassistentFormContext';
import { useTranslation } from 'react-i18next';

export function BerechnungsartDurchschnitt() {
  const { t } = useTranslation();
  const form = useAnlageassistentFormContext();
  const data = form.state.values;
  return (
    <>
      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.berechnungsartMonat.options.durchschnitt',
        )}
      </span>

      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.monatsstunden.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger.monatsstunden +
          ' ' +
          t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.monatsstunden.zusammenfassungSuffix',
          )}
      </span>

      <span>
        {t(
          'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.label',
        )}
      </span>

      <span className="text-neutrals-900 font-semibold">
        <span>
          {data.bezahlung.arbeitszeitkonto.gehaltsempfaenger
            .unbezahlteUeberstundenMonat ?? '00:00'}
        </span>
        <span>
          {` ${t(
            'domain.mitarbeiter.create.steps.bezahlung.sollstunden.form.unbezahlteUeberstundenMonat.zusammenfassungSuffix',
          )}`}
        </span>
      </span>
    </>
  );
}
